module.exports = __webpack_public_path__ + "static/media/Business.04b96394.svg";